import React from 'react';
import { map } from 'lodash';
import SortableHeaderColumn from './sortableHeaderColumn';

const Users = ({ users, handleRowClick }) => {
  return (
    <>
      <table className="table -fixed">
        <tbody>
          <tr className="tr-head -sticky">
            <SortableHeaderColumn colName="first_name">
              First Name
            </SortableHeaderColumn>
            <SortableHeaderColumn colName="last_name">
              Last Name
            </SortableHeaderColumn>
            <SortableHeaderColumn colName="email">
              Email
            </SortableHeaderColumn>
            <SortableHeaderColumn colName="visibility_groups_name">
              Visibility Groups
            </SortableHeaderColumn>
          </tr>
          {
            map(users, (user) => (
              <tr className="body-row" key={ user.id } onClick={ () => {handleRowClick(user);} }>
                <td className="-verizon_cell -pointer">
                  {user.first_name}
                </td>
                <td className="-verizon_cell -pointer">
                  {user.last_name}
                </td>
                <td className="-verizon_cell -pointer">
                  {user.email}
                </td>
                <td className="-verizon_cell -pointer">
                  {map(user.visibility_groups, (vg) => (
                    <div key={ vg.value } className="table_status-label -tag">
                      {vg.label}
                    </div>
                  ))}
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </>
  );
};

export default Users;
